import type { JsonValue } from "@/components/guardians/jsonValue";

/**
 * Raw window params from in-app agent FE tools before coercion to `Record<string, string>`.
 * Includes JSON values and other plain objects that are stringified then parsed.
 */
export type AgentWindowParamValue = JsonValue | object;

export type AgentWindowParams = Record<string, AgentWindowParamValue | undefined>;

function isAgentWindowParamValue(value: unknown): value is AgentWindowParamValue {
  if (value === null) return true;
  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return true;
  }
  return typeof value === "object";
}

/** Narrow untyped agent tool params at the FE-tool boundary. */
export function narrowAgentWindowParams(
  raw: Record<string, unknown> | undefined,
): AgentWindowParams | undefined {
  if (!raw) return undefined;

  const out: AgentWindowParams = {};
  for (const [key, value] of Object.entries(raw)) {
    if (value === undefined) continue;
    if (isAgentWindowParamValue(value)) {
      out[key] = value;
    }
  }
  return out;
}
